import { MouseEvent } from 'react';

import { IdIcon } from '~components/icons/IdIcon';
import { Asset, AssetId } from '~modules/media-library/model/Asset';
import { isAssetVideo } from '~modules/media-library/model/AssetFactory';

type Props = {
  asset: Asset;
  onClick?: (id: AssetId) => void;
  className?: string;
};

export function AssetIdTag({ asset, onClick, className = '' }: Props) {
  function handleClick(evt: MouseEvent<HTMLElement>) {
    evt.stopPropagation();
    evt.preventDefault();
    onClick?.(asset.id);
  }

  const id = isAssetVideo(asset) ? asset.attributes.kalturaId || asset.id : asset.id;

  return (
    <figcaption
      className={`ml--assetid-tag bg-gray bg-opacity-100 rounded flex items-center font-sans text-xs text-metal leading-none px-2 py-1 cursor-text ${className}`}
      onClick={handleClick}
    >
      <IdIcon className="w-4 h-4" />
      <span>{id}</span>
    </figcaption>
  );
}
